var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-header'),_c('v-fade-transition',{attrs:{"hide-on-leave":""}},[_c('router-view')],1),_c('div',{staticStyle:{"z-index":"10"},attrs:{"id":"fb-root"}}),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }